import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bookingActions } from "../../../../../store/reducers/booking";
import { uiActions } from "../../../../../store/reducers/ui";

import { Box, Button, Typography, Alert } from "@mui/material";

import { DateTime } from "luxon";

import constants from "../../../../../utils/constants";
import { generateTimeSlots } from "../../../../../utils/helpers";

export default function TimeSlots(props) {
  const { selectedDateInfo, allocation, calendarInfo } = props;

  const dispatch = useDispatch();

  const handleDateTimeSelected = (dateTime) => {
    const meetingEndDateTime = dateTime.plus({ minutes: allocation }).toISO();

    dispatch(bookingActions.updateClientDetails({ meetingDateTime: dateTime.toISO(), meetingEndDateTime }));
    dispatch(uiActions.nextStep());
  };

  const selectedDate = selectedDateInfo?.date;
  const selectedDateTimeZone = selectedDate ? selectedDate.zone.name : undefined;
  const currentBranchTime = selectedDateTimeZone ? DateTime.now().setZone(selectedDateTimeZone) : undefined;
  const timeSlots = useMemo(() => generateTimeSlots(selectedDateInfo, calendarInfo), [calendarInfo, selectedDateInfo]);
  const slotsArray = timeSlots && Object.keys(timeSlots);

  return (
    <Box id="timeSlots" display="flex" gap={1} flexDirection="column" height="100%">
      <Typography variant="h6" component="div" sx={{ opacity: !selectedDate ? 0.5 : 1 }}>
        Select a time
      </Typography>

      {selectedDate && (
        <>
          <Typography variant="subtitle1">Date: {selectedDate.toLocaleString(DateTime.DATE_FULL)}</Typography>

          <Box display="flex">
            <Typography variant="subtitle2" component="div" flex="auto">
              {constants.TIME_ZONES[selectedDateTimeZone] ?? selectedDateTimeZone}
            </Typography>

            <Typography variant="caption" component="div" color={"#a2a2a2"} flex="auto">
              Current time: {currentBranchTime.toLocaleString(constants.TIME_SIMPLE)}
            </Typography>
          </Box>
        </>
      )}

      {!selectedDate && (
        <Alert severity="warning" sx={{ position: "relative", width: "100%" }}>
          Please select a date first
        </Alert>
      )}

      {/* Slots placeholders removed
        {!slotsArray ? (
          <Grid container justifyContent="center" alignItems="center" height="100%">
            <CircularProgress />
          </Grid>
        ) : ( */}
      {selectedDateInfo && (
        <Box
          display="grid"
          justifyContent="center"
          gap={1}
          gridTemplateColumns="repeat(auto-fit, 80px)"
          width={{ xs: "calc(100vw - 30px)", sm: undefined }}
          maxWidth={{ md: "470px", lg: "700px" }}
          height={{ sm: "100%" }}
          sx={{
            overflow: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#a8a8a8",
            },
          }}
        >
          {slotsArray.map((timeSlot) => {
            const timeSlotObject = timeSlots[timeSlot];

            return (
              <Button
                key={timeSlot}
                size={"small"}
                variant="outlined"
                value={timeSlot}
                disabled={!timeSlots[timeSlot]}
                onClick={() => handleDateTimeSelected(timeSlotObject)}
                sx={{ minWidth: "80px" }}
              >
                {timeSlot.toLocaleString(constants.TIME_SIMPLE)}
              </Button>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
